export function handlerChangeTheme() {
  document.body.classList.toggle('theme-dark');
}
